import { baseX } from './baseX.mjs';

/**
 * A string serializer that uses base58 encoding.
 * @category Serializers
 */
const base58 = baseX('123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz');

export { base58 };
//# sourceMappingURL=base58.mjs.map
